'use client'
import { useEffect, useState } from 'react'
import { superAppSubdomain } from '../constants'
import { getSubdomain } from '../helpers'
import type { SuperappProvider } from '@/superapp/types'
import { getAppUrl } from '@/tools/app-url/client'
import { getConfig } from '@/tools/config'
import { useErrorHandling } from '@/tools/o11y/client'

export const isSuperApp = (): boolean => {
  const { isBrowser } = getConfig()
  if (!isBrowser) {
    throw new Error('[isSuperApp/client] isSuperApp can only be called in the browser context')
  }

  const appUrl = getAppUrl()
  const subdomain = getSubdomain(appUrl)
  if (!subdomain) {
    return false
  }
  return Object.keys(superAppSubdomain).includes(subdomain)
}

export const getSuperAppName = (): SuperappProvider | null => {
  const { isBrowser } = getConfig()
  if (!isBrowser) {
    throw new Error(
      '[getSuperAppName/client] getSuperAppName can only be called in the browser context'
    )
  }

  const appUrl = getAppUrl()
  const subdomain = getSubdomain(appUrl)
  if (!subdomain) {
    return null
  }
  return superAppSubdomain[subdomain] || null
}

export const getAppContext = (): SuperappProvider | 'web' => {
  const superAppName = getSuperAppName()
  return superAppName || 'web'
}

export const useIsSuperApp = () => {
  const [isSuperAppFlag, setIsSuperAppFlag] = useState(false)
  const { execWithErrorTracking } = useErrorHandling()

  useEffect(() => {
    execWithErrorTracking(() => {
      setIsSuperAppFlag(isSuperApp())
    })
  }, [execWithErrorTracking])

  return isSuperAppFlag
}
